import { render, staticRenderFns } from "./ClientePivotTable.vue?vue&type=template&id=26f079d1"
import script from "./ClientePivotTable.vue?vue&type=script&lang=js"
export * from "./ClientePivotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports